import React from "react";
import "../selfcss/vehicle.css";

function Vehicle({ vehicle, onConfirmBooking }) {
    return (
        <div className="row g-0 border rounded overflow-hidden shadow-sm">
            {/* Left Side: Vehicle Image */}
            <div className="col-md-6">
                <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="img-fluids w-100 h-100"
                    style={{ objectFit: "cover" }}
                />
                <div className="text-center py-2 bg-primary text-white">
                    <h5 className="mb-0">{vehicle.name}</h5>
                </div>
            </div>

            {/* Right Side: Vehicle Specs */}
            <div className="col-md-6 d-flex flex-column justify-content-between p-4">
                <div>
                    <h5 className="mb-3">Specifications</h5>
                    <ul className="list-unstyled mb-4">
                        <li>
                            <i className="fa fa-car text-primary me-2"></i>
                            <b>{vehicle.name}</b>
                        </li>
                        <li>
                            <i className="fa fa-users text-primary me-2"></i>
                            {vehicle.specs.passengers}
                        </li>
                        <li>
                            <i className="fa fa-snowflake text-primary me-2"></i>
                            Air Conditioning: {vehicle.specs.airConditioning}
                        </li>
                        <li>
                            <i className="fa fa-user text-primary me-2"></i>
                            Driver Allowance: {vehicle.specs.driverAllowance}
                        </li>
                        <li>
                            <i className="fa fa-road text-primary me-2"></i>
                            Per Km Charge: {vehicle.specs.perKmCharge}
                        </li>
                        <li>
                            <i className="fa fa-money-bill text-primary me-2"></i>
                            Toll Tax: {vehicle.specs.tollTax}
                        </li>
                        <li>
                            <i className="fa fa-suitcase text-primary me-2"></i>
                            Luggage Capacity: {vehicle.specs.luggageCapacity}
                        </li>
                    </ul>
                </div>
                <div className="text-center mt-3">
                    <button className="btn btn-primary w-100"
                     onClick={() => onConfirmBooking(vehicle)}
                    >
                        Confirm Booking
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Vehicle;